/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * Represents a response from a request executed in a batch
 *
 * @export
 * @class BatchResponse
 */
// tslint:disable-next-line:max-classes-per-file
export class BatchResponse {
}
//# sourceMappingURL=IBatch.js.map